import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VigorbuySpreadsheetGuide from "../pages/vigorbuy-spreadsheet-guide/page";
import GuideArticle from "../pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <VigorbuySpreadsheetGuide />,
  },
  {
    path: "/guide/:slug",
    element: <GuideArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;